
import React from 'react';
import { Flame } from 'lucide-react';

interface TrendingBadgeProps {
  score: number;
  size?: 'sm' | 'md' | 'lg';
}

const TrendingBadge: React.FC<TrendingBadgeProps> = ({ 
  score, 
  size = 'md'
}) => {
  // Only show if trending (score > threshold)
  if (score < 50) return null;
  
  // Determine intensity based on score
  const getIntensity = () => {
    if (score > 200) return 'hot';
    if (score > 100) return 'trending';
    return 'popular';
  };
  
  const intensity = getIntensity();
  
  // Define styles based on intensity
  const getStyles = () => {
    switch (intensity) {
      case 'hot':
        return 'bg-red-600 text-white border-red-700';
      case 'trending':
        return 'bg-orange-500 text-white border-orange-600';
      default:
        return 'bg-yellow-400 text-black border-yellow-500';
    }
  };
  
  // Size variants with proper spacing for full text
  const sizeClasses = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-sm px-2 py-1',
    lg: 'text-base px-3 py-1'
  };
  
  // Get display text based on intensity
  const getDisplayText = () => {
    switch (intensity) {
      case 'hot':
        return 'Hot';
      case 'trending':
        return 'Trending';
      default:
        return 'Popular';
    }
  };
  
  return (
    <div className={`
      inline-flex items-center gap-1 rounded-full border flex-shrink-0
      ${getStyles()} 
      ${sizeClasses[size]}
      whitespace-nowrap
    `}>
      <Flame className={`flex-shrink-0 ${size === 'sm' ? 'h-3 w-3' : 'h-4 w-4'}`} />
      <span>
        {getDisplayText()}
      </span>
    </div>
  );
};

export default TrendingBadge;
